export default "__VITE_ASSET__DoGDpwpj__"